<div class="container">
  <div class="d-flex pt-3 pb-4">
    <!-- Back Button -->
    <div class="cursor-pointer back-button d-flex align-items-center" [routerLink]="'/rewards/wallet'">
      <span class="icon material-icons text-primary pe-2">keyboard_arrow_left</span>
      <span class="font-size-14 font-praktika-bold text-primary">{{ 'claimed.back.to.wallet' | translate }}</span>
    </div>
    <!-- Title -->
    <h5 class="m-0 wallet-redeemed-title text-info font-size-20 font-heading text-uppercase">
      {{ 'wallet.redeemed.title' | translate }}
    </h5>
    <div class="back-button"></div>
  </div>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [pageSize]="0"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="container">
    <div class="border-disabled bg-primary">
      <div class="font-praktika-bold font-size-12 text-center py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
